// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/reorder_project_images.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/reorder_project_images.proto.
 */
export const file_vision_assets_v1_reorder_project_images: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYXNzZXRzL3YxL3Jlb3JkZXJfcHJvamVjdF9pbWFnZXMucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIrABChtSZW9yZGVyUHJvamVjdEltYWdlc1JlcXVlc3QSSwoGcGFyYW1zGAEgASgLMjsucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuUmVvcmRlclByb2plY3RJbWFnZXNSZXF1ZXN0LlBhcmFtcxpECgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRITCgtsb2NhdGlvbl9pZBgCIAEoCRIRCglpbWFnZV9pZHMYAyADKAkidgocUmVvcmRlclByb2plY3RJbWFnZXNSZXNwb25zZRJMCgZyZXN1bHQYASABKAsyPC5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5SZW9yZGVyUHJvamVjdEltYWdlc1Jlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.assets.v1.ReorderProjectImagesRequest
 */
export type ReorderProjectImagesRequest = Message<"protos.vision.assets.v1.ReorderProjectImagesRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ReorderProjectImagesRequest.Params params = 1;
   */
  params?: ReorderProjectImagesRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ReorderProjectImagesRequest.
 * Use `create(ReorderProjectImagesRequestSchema)` to create a new message.
 */
export const ReorderProjectImagesRequestSchema: GenMessage<ReorderProjectImagesRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_reorder_project_images, 0);

/**
 * @generated from message protos.vision.assets.v1.ReorderProjectImagesRequest.Params
 */
export type ReorderProjectImagesRequest_Params = Message<"protos.vision.assets.v1.ReorderProjectImagesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;

  /**
   * @generated from field: repeated string image_ids = 3;
   */
  imageIds: string[];
};

/**
 * Describes the message protos.vision.assets.v1.ReorderProjectImagesRequest.Params.
 * Use `create(ReorderProjectImagesRequest_ParamsSchema)` to create a new message.
 */
export const ReorderProjectImagesRequest_ParamsSchema: GenMessage<ReorderProjectImagesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_reorder_project_images, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.ReorderProjectImagesResponse
 */
export type ReorderProjectImagesResponse = Message<"protos.vision.assets.v1.ReorderProjectImagesResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ReorderProjectImagesResponse.Result result = 1;
   */
  result?: ReorderProjectImagesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ReorderProjectImagesResponse.
 * Use `create(ReorderProjectImagesResponseSchema)` to create a new message.
 */
export const ReorderProjectImagesResponseSchema: GenMessage<ReorderProjectImagesResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_reorder_project_images, 1);

/**
 * @generated from message protos.vision.assets.v1.ReorderProjectImagesResponse.Result
 */
export type ReorderProjectImagesResponse_Result = Message<"protos.vision.assets.v1.ReorderProjectImagesResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.ReorderProjectImagesResponse.Result.
 * Use `create(ReorderProjectImagesResponse_ResultSchema)` to create a new message.
 */
export const ReorderProjectImagesResponse_ResultSchema: GenMessage<ReorderProjectImagesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_reorder_project_images, 1, 0);

